import { getCookie } from "cookies-next";
import client from "../client";

export interface UfabetTransferInRequest {
  amount: number;
}

export interface UfabetTransferInResponse {
  status?: "success" | "error";
  message?: string;
  data?: {
    member_id?: number;
    ufabet_username?: string;
    amount?: number;
    member_balance?: number;
    ufabet_balance?: number;
    transaction_id?: string;
    ufabet_tx_id?: string;
    transfer_type?: string;
  };
}

/**
 * API สำหรับโยกเงินจากระบบเข้า UFABET
 * Route: ufabet/member/transfer-in
 * Method: POST
 * @param request - Object ที่มี amount
 * @returns Promise<UfabetTransferInResponse>
 *
 * @example
 * const response = await ufabetTransferIn({ amount: 100 });
 * if (response.status === 'success') {
 *   console.log('Transfer completed:', response.data?.transaction_id);
 * }
 */
export default async function ufabetTransferIn(
  request: UfabetTransferInRequest
): Promise<UfabetTransferInResponse | undefined> {
  try {
    if (!request.amount || request.amount <= 0) {
      return {
        status: "error",
        message: "จำนวนเงินต้องมากกว่า 0",
      };
    }

    const response = await client.post<UfabetTransferInResponse>(
      "/ufabet/member/transfer-in",
      {
        amount: request.amount,
      },
      {
        headers: {
          Authorization: `Bearer ${getCookie("access_token")?.toString()}`,
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Error transferring in to UFABET:", error);
    return {
      status: "error",
      message:
        error.response?.data?.message ||
        "ไม่สามารถโยกเงินได้ กรุณาลองใหม่อีกครั้ง",
    };
  }
}
